/**
 * Indica se a aula é do tipo vídeo conforme a API (campo `type` / `tipoOriginal`).
 * Usar antes de chamar endpoints exclusivos de progresso de vídeo.
 *
 * @param {{ tipo?: string | null, tipoOriginal?: string | null } | null | undefined} aula
 * @returns {boolean}
 */
export function isLessonVideoType(aula) {
    if (!aula) {
        return false;
    }

    const tipoOriginal = aula.tipoOriginal ?? aula.tipo;
    return tipoOriginal === 'video';
}
